const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const ProductServiceCommand: any = {
    GetProductDetailByProductIdList: Backofficebff + '/v1/product/get-product-detail-by-productId',
};
